import React from "react";
import { useNewsletterContext } from "~/components/newsletter/newsletter-widget/contexts";
import { findFirstNonEmptyString } from "~/lib/utils";
import { Container, SubTitle, Title } from "./styles";
export const TitleDisplay = ({
  className
}) => {
  const {
    newsletterItemForDisplay
  } = useNewsletterContext();
  const computedNewsletterTitle = findFirstNonEmptyString(newsletterItemForDisplay === null || newsletterItemForDisplay === void 0 ? void 0 : newsletterItemForDisplay.name, newsletterItemForDisplay === null || newsletterItemForDisplay === void 0 ? void 0 : newsletterItemForDisplay.alternativeName);
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    "data-qa": "title-display"
  }, /*#__PURE__*/React.createElement(SubTitle, null, "Sign-up for"), /*#__PURE__*/React.createElement(Title, null, computedNewsletterTitle));
};
TitleDisplay.displayName = "TitleDisplay";